import { render } from "./z-pagination.vue?vue&type=template&id=67c8b220"
import script from "./z-pagination.vue?vue&type=script&lang=js"
export * from "./z-pagination.vue?vue&type=script&lang=js"

import "./z-pagination.vue?vue&type=style&index=0&id=67c8b220&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__